import React, { useState } from 'react'
import { Box, Button, Flex, Heading, Message, toast } from '@workwhile/ui'
import { useAttachJurisdictionFlowContextValue } from '../context/AttachJurisdictionFlowProvider'
import { useRuleDetailContextValue } from '../../../context/RuleDetailProvider'
import { useRuleDetailWorkflowsContextValue } from '../../../context/RuleDetailWorkflowsProvider'
import { ModalSelect, ModalWithSelect } from 'components/ModalSelect'

type JurisdictionOption = { label: string; value: number }

export const AttachJurisdictionFlowMain = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  const {
    attachJurisdictionFlow: { isOpen, close },
  } = useRuleDetailWorkflowsContextValue()

  const {
    state: {
      jurisdictionOptions,
      mutationState: { isPending, errorMessage },
    },
    actions: { submit },
  } = useAttachJurisdictionFlowContextValue()

  const [selectedOption, setSelectedOption] =
    useState<JurisdictionOption | null>(null)

  const handleClose = () => {
    setSelectedOption(null)
    close()
  }

  const onSubmit = () => {
    if (!selectedOption) return
    submit(
      { ruleId, jurisdictionId: selectedOption.value },
      {
        onSuccess: () => {
          toast.success('Jurisdiction attached', { position: 'top-center' })
          handleClose()
        },
      }
    )
  }

  return (
    <ModalWithSelect
      open={isOpen}
      onClose={handleClose}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={!selectedOption}
          >
            Attach
          </Button>
        </Flex>
      }
    >
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        Attach jurisdiction
      </Heading>
      <Box mt={3}>
        <ModalSelect
          options={jurisdictionOptions}
          value={selectedOption}
          onChange={(option: JurisdictionOption | null) =>
            setSelectedOption(option)
          }
          placeholder="Search by name or ID..."
          filterOption={(option, input) => {
            const q = input.toLowerCase()
            return (
              option.label.toLowerCase().includes(q) ||
              option.value.toString().includes(q)
            )
          }}
        />
      </Box>
      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </ModalWithSelect>
  )
}
